import Chip, { ChipProps } from '@mui/material/Chip'

export const NewChip = (props: ChipProps): JSX.Element => {
  return (
    <Chip
      label='New'
      variant='filled'
      color='primary'
      size='small'
      sx={{
        margin: 0,
        height: '24px',
        borderRadius: '0.25rem 0 0.5rem 0',
        padding: '0 0.5rem',
        fontWeight: 600,
      }}
    />
  )
}
